import React from 'react';
import cn from 'classnames';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import ArrowRight from '@wix/da-ds/pkg/Icons/16x16/ArrowRight';

import s from './FormStepsDisplay.scss';

export interface Props {
  currentStep: number;
  steps: [string, string];
}

export const FormStepsDisplay: React.FC<Props> = ({ currentStep, steps }) => {
  return (
    <div className={s['root']}>
      <div className={cn(s['step'], currentStep === 1 && s['current'])}>{steps[0]}</div>
      <ArrowRight size={IconSize.SMALL} />
      <div className={cn(s['step'], currentStep === 2 && s['current'])}>{steps[1]}</div>
    </div>
  );
};

FormStepsDisplay.displayName = 'FormStepsDisplay';
export default FormStepsDisplay;
